import { render } from "./FollowHorse.vue?vue&type=template&id=c1e21a86"
import script from "./FollowHorse.vue?vue&type=script&lang=js"
export * from "./FollowHorse.vue?vue&type=script&lang=js"

import exportComponent from "/Users/iomac/Progetti/equiup/equiupmaneggi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__